<template>
  <div id="appStatisticPage">
    <h2>热门应用统计</h2>
    <v-chart :option="appAnswerCountOptions" style="height: 300px"></v-chart>
    <h2>应用结果统计</h2>
    <div class="search-bar">
      <a-input-search
        style="width: 320px"
        placeholder="输入 appId"
        button-text="搜索"
        size="large"
        search-button
        @search="(value:string) => loadAppAnswerResultCountData(value)"
      ></a-input-search>
    </div>
    <div style="margin-bottom: 16px"></div>
    <v-chart
      :option="appAnswerResultCountOptions"
      style="height: 300px"
    ></v-chart>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watchEffect } from "vue";
import "echarts";
import VChart from "vue-echarts";
import API from "@/api";
import {
  doAppAnswerCountUsingGet,
  doAppAnswerResultCountUsingGet,
} from "@/api/appStatisticController";
import { Message } from "@arco-design/web-vue";
const appAnswerCountList = ref<API.AppAnswerCountDTO[]>();
const appAnswerResultCountList = ref<API.AppAnswerResultCountDTO[]>([]);

const loadAppAnswerCountData = async () => {
  const res = await doAppAnswerCountUsingGet();
  if (res.data.code === 0) {
    appAnswerCountList.value = res.data.data || [];
  } else {
    Message.error("获取数据失败，" + res.data.message);
  }
};

const loadAppAnswerResultCountData = async (appId: string) => {
  if (!appId) {
    return;
  }
  const res = await doAppAnswerResultCountUsingGet({
    appId: appId as any,
  });
  if (res.data.code === 0) {
    appAnswerResultCountList.value = res.data.data || [];
  } else {
    Message.error("获取数据失败，" + res.data.message);
  }
};

/*
 * 参数改变时触发数据的重新加载
 * */
watchEffect(() => {
  loadAppAnswerCountData();
  loadAppAnswerResultCountData("");
});

const appAnswerCountOptions = computed(() => {
  return {
    xAxis: {
      type: "category",
      data: appAnswerCountList.value?.map((item) => item.appId),
      name: "应用 id",
    },
    yAxis: {
      type: "value",
      name: "用户答案数",
    },
    series: [
      {
        data: appAnswerCountList.value?.map((item) => item.answerCount),
        type: "bar",
      },
    ],
  };
});

const appAnswerResultCountOptions = computed(() => {
  return {
    tooltip: {
      trigger: "item",
    },
    legend: {
      orient: "vertical",
      left: "left",
    },
    series: [
      {
        name: "应用答案结果分布",
        type: "pie",
        radius: "50%",
        data: appAnswerResultCountList.value?.map((item) => {
          return { value: item.resultCount, name: item.resultName };
        }),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };
});
</script>

<style scoped></style>
